<div class="p-3 p-lg-4 contract-shell">
  <div class="d-flex align-items-center gap-3 contract-header">
    <span class="title-badge">
      <lucide-icon [img]="FileTextIcon" [size]="20"></lucide-icon>
    </span>
    <h1 class="m-0 contract-title">Contract Management</h1>
  </div>

@if (estimatedProfitModal(); as modal) {
  <div class="profit-modal-backdrop" (click)="closeEstimatedProfitModal()"></div>
  <div class="profit-modal-card" role="dialog" aria-modal="true" aria-label="Estimated profit details">
    <div class="profit-modal-head">
      <div>
        <h2 class="profit-modal-title">{{ modal.title }}</h2>
        <div class="profit-modal-subtitle">{{ modal.subtitle }}</div>
      </div>
      <button type="button" class="profit-modal-close" (click)="closeEstimatedProfitModal()">
        <lucide-icon [img]="CloseIcon" [size]="16"></lucide-icon>
      </button>
    </div>
    <div class="profit-modal-body">
      <div class="profit-modal-equation">{{ modal.equation }}</div>
      <div class="profit-modal-hint">{{ modal.hint }}</div>
      <div class="profit-modal-summary">{{ modal.summaryLine }}</div>
      <table class="table table-sm profit-modal-table mb-0">
        <tbody>
          @for (detail of modal.details; track detail.label) {
            <tr>
              <td class="fw-semibold">{{ detail.label }}</td>
              <td>{{ detail.value }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}

  <div class="pt-3">
    <div class="row g-2 mb-3">
      @for (tile of summaryTiles(); track tile.label) {
        <div class="col-12 col-md-6 col-xl">
          <div class="metric-card h-100">
            <div class="metric-head">
              <div class="metric-title-wrap">
                <span class="metric-icon-box">
                  <lucide-icon [img]="tile.icon" [size]="16"></lucide-icon>
                </span>
                <div class="metric-label">{{ tile.label }}</div>
              </div>
              <div class="metric-count">{{ tile.count }}</div>
            </div>
            <div class="metric-sep"></div>
            @for (item of tile.categories; track item.label) {
              <div
                class="metric-row"
                [class.clickable]="canFilterSummaryCategory(tile.label)"
                (click)="applySummaryCategoryFilter(tile.label, $any(item.key), item.label)"
              >
                <div
                  class="metric-category"
                  [class.sale]="item.key === 'sale'"
                  [class.bank]="item.key === 'bank'"
                  [class.hybrid]="item.key === 'hybrid'"
                  [class.bess]="item.key === 'bess'"
                  [class.active-filter]="canFilterSummaryCategory(tile.label) && isSummaryCategoryActive(tile.label, $any(item.key))"
                >
                  <span>{{ item.label }}</span>
                  <span class="metric-badge">{{ item.count }}</span>
                </div>
                <div class="metric-mw">{{ item.mw }} MW</div>
              </div>
            }
          </div>
        </div>
      }
    </div>

    <div class="content-card p-3 p-lg-4">
      <div class="tool-card mb-3">
        <div class="toolbar-top">
          <div class="filters-grid">
            <div class="field-wrap">
              <span class="field-label">Approval Status</span>
              <select class="form-select compact-control" [value]="draftStatus()" (change)="draftStatus.set(($any($event.target).value || '').toString())">
                <option value="all">All Status</option>
                <option value="approved">Approved</option>
                <option value="pending">Pending</option>
                <option value="rejected">Rejected</option>
                <option value="draft">Draft</option>
                <option value="active">Active</option>
              </select>
            </div>
            <div class="field-wrap">
              <span class="field-label">Contract Status</span>
              <select class="form-select compact-control" [value]="draftContractStatus()" (change)="draftContractStatus.set(($any($event.target).value || '').toString())">
                <option value="all">All Contract Status</option>
                <option value="active">Active</option>
                <option value="expired">Expired</option>
                <option value="starts_next_month">Starts Next Month</option>
                <option value="upcoming">Upcoming</option>
              </select>
            </div>
            <div class="field-wrap">
              <span class="field-label">From Date</span>
              <input class="form-control compact-control" type="date" [value]="draftFromDate()" (input)="draftFromDate.set(($any($event.target).value || '').toString())" />
            </div>
            <div class="field-wrap">
              <span class="field-label">To Date</span>
              <input class="form-control compact-control" type="date" [value]="draftToDate()" (input)="draftToDate.set(($any($event.target).value || '').toString())" />
            </div>
            <div class="field-wrap search-wrap">
              <span class="field-label">Search Contract</span>
              <div class="search-field-shell">
                <input class="form-control compact-control pe-4" placeholder="Search..." [value]="draftSearch()" (input)="draftSearch.set(($any($event.target).value || '').toString())" />
                <lucide-icon [img]="SearchIcon" [size]="16" class="search-icon"></lucide-icon>
              </div>
            </div>
            <div class="filter-buttons">
              <button class="filter-btn go" (click)="applyFilters()">GO</button>
              <button class="filter-btn clear" (click)="resetFilters()">CLEAR</button>
              <button class="icon-only-btn" (click)="exportContracts()" title="Export">
                <lucide-icon [img]="FileDownIcon" [size]="16"></lucide-icon>
              </button>
              @if (!isVendorUser()) {
                <button class="cta-btn primary" (click)="router.navigateByUrl('/contracts/new')">
                  <span class="cta-icon"><lucide-icon [img]="PlusIcon" [size]="12"></lucide-icon></span>
                  <span>ADD CONTRACT</span>
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="table-wrap">
        <div class="table-scroll">
          <table class="table contract-table mb-0">
            <thead class="sticky-top">
              <tr>
                <th>S.No.</th>
                <th>Contract Number</th>
                <th>Contract Type</th>
                <th>Contract Category</th>
                <th>Created Date</th>
                <th>Contract Period</th>
                <th>Seller</th>
                <th>Seller LOA</th>
                <th>Buyer</th>
                <th>Buyer LOA</th>
                <th>Application Count</th>
                <th>Import Quantum (MWh)</th>
                <th>Export Quantum (MWh)</th>
                <th class="d-none">Return Percentage</th>
                <th class="profit-col">Estimated Profit</th>
                <th class="profit-col">Actual Profit</th>
                <th>Contract Status</th>
                <th>Compatibility Status</th>
                <th>Approval Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
            @if (loading()) {
              <tr><td colspan="20" class="text-center py-5 text-muted">Loading Contract Management...</td></tr>
            } @else if (pagedContracts().length === 0) {
              <tr><td colspan="20" class="text-center py-5 text-muted">No Records Found</td></tr>
            }
            @for (contract of pagedContracts(); track contract.id; let i = $index) {
              <tr>
                @let row = rowDisplay(contract);
                <td>{{ (page() - 1) * pageSize() + i + 1 }}</td>
                <td class="fw-medium">{{ contract.contract_number }}</td>
                <td><span class="badge-type">{{ contract.contract_type || 'STOA' }}</span></td>
                <td>{{ contractCategory(contract) }}</td>
                <td>{{ formatDate(contract.created_at) }}</td>
                <td>{{ formatDate(contract.period_from) }} - {{ formatDate(contract.period_to) }}</td>
                <td>
                  @if (row.sellerVendorId) {
                    <a class="loa-link" (click)="openVendorDetails(row.sellerVendorId)">{{ row.seller }}</a>
                  } @else {
                    {{ row.seller }}
                  }
                </td>
                <td>
                  @if (row.sellerLoaId) {
                    <a class="loa-link" (click)="openLoaDetails(row.sellerLoaId)">{{ row.sellerLoa }}</a>
                  } @else {
                    {{ row.sellerLoa }}
                  }
                </td>
                <td>
                  @if (row.buyerVendorId) {
                    <a class="loa-link" (click)="openVendorDetails(row.buyerVendorId)">{{ row.buyer }}</a>
                  } @else {
                    {{ row.buyer }}
                  }
                </td>
                <td>
                  @if (row.buyerLoaId) {
                    <a class="loa-link" (click)="openLoaDetails(row.buyerLoaId)">{{ row.buyerLoa }}</a>
                  } @else {
                    {{ row.buyerLoa }}
                  }
                </td>
                <td [attr.title]="applicationTooltip(contract.id)">
                  <span class="application-count-badge">{{ applicationCount(contract.id) }}</span>
                </td>
                <td>{{ row.importQuantum }}</td>
                <td>{{ row.exportQuantum }}</td>
                <td class="d-none">{{ formatReturnPercentage(row.returnPercentage) }}</td>
                <td class="profit-col">
                  <button type="button" class="profit-trigger" [class]="profitValueClass(estimatedProfit(contract))" (click)="openEstimatedProfitModal(contract)">
                    {{ formatProfitValue(estimatedProfit(contract)) }}
                  </button>
	                </td>
	                <td class="profit-col">
	                  @let actual = actualProfit(contract);
	                  <button
	                    type="button"
	                    class="profit-trigger"
	                    [disabled]="actual === null || actual === undefined"
	                    [class]="profitValueClass(actual)"
	                    (click)="openActualProfitModal(contract)"
	                  >
	                    {{ formatProfitValue(actual) }}
	                  </button>
	                </td>
	                <td><span [class]="getContractLifecycleStatusClass(contract)">{{ getContractLifecycleStatusLabel(contract) }}</span></td>
	                <td>{{ contract.compatibility_status || 'Pending' }}</td>
                <td><span [class]="getStatusClass(contract.status)">{{ getStatusLabel(contract.status) }}</span></td>
                <td>
                  <div class="table-action-group">
                    @if (!isVendorUser()) {
                      <button class="table-icon-btn edit" [disabled]="!canEdit(contract)" [attr.title]="editButtonTitle(contract)" (click)="router.navigateByUrl('/contracts/' + contract.id + '/edit')">
                        <lucide-icon [img]="PencilIcon" [size]="14"></lucide-icon>
                      </button>
                    }
                    <button class="table-icon-btn view" title="View" (click)="router.navigateByUrl('/contracts/' + contract.id)">
                      <lucide-icon [img]="EyeIcon" [size]="14"></lucide-icon>
                    </button>
                    @if (!isVendorUser()) {
                      <button class="table-icon-btn view" [disabled]="!canDelete(contract)" [attr.title]="deleteButtonTitle(contract)" (click)="deleteContract(contract)">
                        <lucide-icon [img]="Trash2Icon" [size]="14"></lucide-icon>
                      </button>
                    }
                  </div>
                </td>
              </tr>
            }
            </tbody>
          </table>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center gap-2 py-3 px-2 pager-wrap flex-wrap">
        <div class="pager-meta">{{ startRow() }}-{{ endRow() }} of {{ filteredContracts().length }} contracts</div>
        <div class="pagination-shell">
          <button class="pager-btn" [disabled]="page() <= 1" (click)="goFirst()">
            <lucide-icon [img]="ChevronsLeftIcon" [size]="14"></lucide-icon>
          </button>
          <button class="pager-btn" [disabled]="page() <= 1" (click)="page.set(page() - 1)">
            <lucide-icon [img]="ChevronLeftIcon" [size]="14"></lucide-icon>
          </button>
          <span class="page-indicator current">{{ page() }}</span>
          <button class="pager-btn" [disabled]="page() >= totalPages()" (click)="page.set(page() + 1)">
            <lucide-icon [img]="ChevronRightIcon" [size]="14"></lucide-icon>
          </button>
          <button class="pager-btn" [disabled]="page() >= totalPages()" (click)="goLast()">
            <lucide-icon [img]="ChevronsRightIcon" [size]="14"></lucide-icon>
          </button>
          <select class="page-size-select" [value]="pageSize()" (change)="onPageSizeChange(($any($event.target).value || '10').toString())">
            @for (size of pageSizes; track size) {
              <option [value]="size">{{ size }}/Page</option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>
</div>
